type VidyardAPI = {
    getPlayers(): Player[];
    addReadyListener(
        callback: (_: any, player: Player) => void,
        uuid?: string | null
    ): void;
};

type Player = {
    play: () => void;
    pause: () => void;
    on: (event: string, callback: () => void) => void;
    element: HTMLElement;
    container?: HTMLElement;
}

declare global {
    interface Window {
        VidyardV4?: {
            players?: Player[];
            api?: VidyardAPI;
        };
        onVidyardAPI?: (vidyardEmbed: { api: VidyardAPI }) => void;
    }
}

export const otVidyard = {
    init() {
        const videos: NodeListOf<HTMLElement> = document.querySelectorAll('.js-vidyard-player-embed');

        videos?.forEach((video) => {
            video.addEventListener('click', (e) => this.activateVidyard(e, videos));
        });
    },
    activateVidyard(e: Event, videos: NodeListOf<HTMLElement>) {
        if (window.VidyardV4) return;

        const script = document.createElement('script');
        script.src = 'https://play.vidyard.com/embed/v4.js';
        document.head.appendChild(script);
        const $eventTarget = e.target as HTMLElement;

        this.handleVidyardEvents($eventTarget);
    },
    handleVidyardEvents($eventTarget: HTMLElement) {
        window.onVidyardAPI = (vidyardEmbed) => {
            vidyardEmbed.api.addReadyListener((_, player) => {
                this.removePlayBtn(player.element);

                if (player.container && $eventTarget?.closest('.vidyard-player-container') == player.container) {
                    player.play()
                }

                player.on('play', () => {
                    window.VidyardV4?.players?.forEach((queriedPlayer: Player) => {
                        if (queriedPlayer !== player) queriedPlayer.pause();
                    });
                })
            }, ) // pass empty 2nd arg (uuid) so this runs on multiple videos
        }
    },
    removePlayBtn($element: HTMLElement) {
        const $playBtn = $element.closest('.js-vidyard-player-embed')?.querySelector('.js-vidyard-play-button');

        if (!$playBtn) return;

        $playBtn?.classList.add('opacity-0');
        const transitionDuration = getComputedStyle($playBtn).transitionDuration ?? 0;
        const durationMs = parseFloat(transitionDuration) * 1000;

        setTimeout(() => {
            $playBtn.remove();
        }, durationMs);
    }
}